"use client";

import { ErrorPageContent } from "@/components/shared/ErrorPage";
import { Card, CardContent } from "@/components/ui/card";
import { getLastCorrelationIdSnapshot } from "@/contexts/CorrelationContext";
import { useErrorPage } from "@/hooks/error/useErrorPage";

interface GlobalErrorProps {
  error: Error & { digest?: string; correlationId?: string };
}

export default function GlobalError({ error }: GlobalErrorProps): React.JSX.Element {
  const { identifier, displayError } = useErrorPage({
    error,
    getCorrelationId: getLastCorrelationIdSnapshot,
  });

  return (
    <html lang="en">
      <body className="antialiased">
        <div className="flex min-h-screen items-center justify-center bg-cede-bg-primary p-4">
          <Card className="w-full max-w-md">
            <CardContent className="pt-6">
              <ErrorPageContent error={displayError} supportId={identifier} showErrorDetails={true} />
            </CardContent>
          </Card>
        </div>
      </body>
    </html>
  );
}
